<script setup>
/**
 * Navigation drawer sidebar that slides in from the side of the screen.
 *
 * @status recommended
 * @group navigation
 * @useWhen Building a side navigation panel that toggles open and closed
 * @within hr-layout
 * @see https://quasar.dev/layout/drawer Quasar q-drawer API
 */
defineOptions({ name: 'HrDrawer' });
</script>

<template>
  <q-drawer
    v-bind="$attrs"
    class="hr-drawer"
  >
    <!-- @slot Navigation content, typically a list of HrNavItem/HrNavGroup components. -->
    <slot />
  </q-drawer>
</template>

<style>
/* Quasar forwards inherited classes onto .q-drawer__content, so hr-drawer lands on that element directly */
.q-drawer__content.hr-drawer {
  background: var(--app-comp-nav-drawer-container);
  color: var(--app-comp-nav-drawer-on-container);
}
</style>
